export enum EstadoCampanhaENUM {
    Rascunho = 1,
    Pendente = 2,
    Publicado = 3,
    EmCurso = 4,
    Suspensa = 5,
    Sucesso = 6,
    Encerrada = 8,
    Recusado = 7,
    Concluída = 9
}

export const EstadoCampanhaDescricao: Record<number, string> = {
    1: 'Rascunho',
    2: 'Pendente',
    3: 'Publicado',
    4: 'Em curso',
    5: 'Suspensa',
    6: 'Sucesso',
    8: 'Encerrada',
    7: 'Recusado',
    9: 'Concluída'
};
